var PaymentProviders;
(function (PaymentProviders) {
    PaymentProviders["Coupon"] = "COUPON";
    PaymentProviders["MoneyPlatform"] = "MONEYPLATFORM";
    PaymentProviders["Stripe"] = "STRIPE";
})(PaymentProviders || (PaymentProviders = {}));
export { PaymentProviders };
